import { format } from 'date-fns';

export const formatToISODate = (date: Date) => {
  const dateObj = new Date(date);
  const formattedDate = format(dateObj, 'yyyy-MM-dd');

  return formattedDate;
};

export const formatToLocalizedDateTime = (dateString: string, lang: "en" | "ar", includeTime: boolean = true) => {
  const locale = lang === 'ar' ? 'ar-EG' : 'en-GB';
  const dateWithoutOffset = dateString.replace(/([+-]\d{2}:\d{2}|Z)$/, '');
  const date = new Date(`${dateWithoutOffset}Z`);

  const datePart = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);

  const timePart = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC',
  }).format(date);

  return includeTime ? `${datePart}, ${timePart.toUpperCase()}` : datePart;
};


const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;
const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;
const SECONDS_IN_WEEK = SECONDS_IN_DAY * 7;
const SECONDS_IN_MONTH = SECONDS_IN_DAY * 30;
const SECONDS_IN_YEAR = SECONDS_IN_DAY * 365;
const MILLISECONDS_IN_SECOND = 1000;

const RELATIVE_TIME_UNITS = [
  { unit: "year", seconds: SECONDS_IN_YEAR },
  { unit: "month", seconds: SECONDS_IN_MONTH },
  { unit: "week", seconds: SECONDS_IN_WEEK },
  { unit: "day", seconds: SECONDS_IN_DAY },
  { unit: "hour", seconds: SECONDS_IN_HOUR },
  { unit: "minute", seconds: SECONDS_IN_MINUTE },
  { unit: "second", seconds: 1 },
] as const;

export const timeAgo = (
  dateString: string,
  lang: "en" | "ar" = "en"
): string => {
  const date = new Date(dateString);
  const now = new Date();

  const differenceInSeconds = Math.floor(
    (date.getTime() - now.getTime()) / MILLISECONDS_IN_SECOND
  );

  const formatter = new Intl.RelativeTimeFormat(
    lang === "ar" ? "ar-EG" : "en",
    {
      numeric: "always",
    }
  );

  const relativeTimeUnit = RELATIVE_TIME_UNITS.find(
    ({ seconds }) => Math.abs(differenceInSeconds) >= seconds
  );

  if (!relativeTimeUnit) {
    return formatter.format(0, "second");
  }

  const value = Math.round(
    differenceInSeconds / relativeTimeUnit.seconds
  );

  return formatter.format(value, relativeTimeUnit.unit);
};